import React from "react";
import sumBy from "lodash/sumBy"
import isEmpty from "lodash/isEmpty"

import {
  Badge,
  Media
} from 'reactstrap';

const Calculate = (props) => {

  // no adding rateUSDtoMYR
  // calculated from checkout(main)
  const countShipping = () => {
    if(props.currency === "USD"){
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(props.shippingFee)
    }else{
      return new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format((props.shippingFeeMYR))
    }
  }
  
  return (  
    <>
      <div>
        <div className="border-bottom pb-3">
          <table className="product-table w-100">
            <thead className="product-table__header">
              <tr>
                <th scope="col"><span className="visually-hidden">Image</span></th>
                <th scope="col"><span className="visually-hidden">Name</span></th>
                <th scope="col"><span className="visually-hidden">Variations</span></th>
                <th scope="col"><span className="visually-hidden">Total Price</span></th>
              </tr>
            </thead>
            <tbody>
            {props.carts.length > 0?
              props.carts.map((v, i) => {
                return (
                  <tr className="product" key={i}>
                    <td className="product__image">
                      <div className="product-thumbnail ">
                        <div className="product-thumbnail__wrapper">
                          {v.productImg?(
                            <img className="product-thumbnail__image" src={v.productImg} alt="pracworks" />
                          ):<h4>No Image <br/>Preview</h4>}
                          {/* <img alt="pracworks carbon" className="product-thumbnail__image" src="//cdn.shopify.com/s/files/1/3012/8606/products/2-600x600_83ea478c-bb3f-4036-a783-7b481e2f1315_small.jpg?v=1569124598" /> */}
                        </div>
                        <span className="product-thumbnail__quantity" aria-hidden="true">{v.quantity}</span>
                      </div>
                    </td>
                    <th className="product__description" scope="row">
                      <span className="product__description__name order-summary__emphasis">{v.name}</span>
                      {/* <span className="product__description__variant order-summary__small-text">Original</span> */}
                    </th>
                    <td className="text-left">
                      {v.variations?
                        v.variations.length > 0? (
                          <ul className="mb-2 text-capitalize">
                            {v.variations.map((v1, i1) => {
                              return (
                                <li key={i1}>- {v1.value} (
                                  <p className="cart-price mb-0 d-inline-block">
                                    <span className="money">
                                    +{
                                      props.currency === "USD"? 
                                        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v1.oriTotalAmount)
                                        :
                                        new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(v1.oriTotalAmountMYR)
                                    }
                                    </span>
                                  </p>
                                )</li>
                              )
                            })}
                          </ul>
                        )
                        :null
                      :null}
                    </td>
                    <td className="product__price text-right">
                      <span className="order-summary__emphasis skeleton-while-loading">
                        {/* {props.currency === "USD"? 
                          new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                            v.oriTotalNetAmount+(!isEmpty(v.variations)?sumBy(v.variations, "oriTotalAmount"):0)
                          )
                          :
                          new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                            ((v.oriTotalNetAmount+(!isEmpty(v.variations)?sumBy(v.variations, "oriTotalAmount"):0))*props.rateUSDtoMYR)
                          )
                        } */}
                        {props.currency === "USD"? 
                          new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                            v.oriTotalNetAmount
                          )
                          :
                          new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                            v.oriTotalNetAmountMYR
                          )
                        }
                        <br/>
                        {props.currency === "USD"? 
                          new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                            (!isEmpty(v.variations)?sumBy(v.variations, "oriTotalAmount"):0)
                          )
                          :
                          new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                            (!isEmpty(v.variations)?sumBy(v.variations, "oriTotalAmountMYR"):0)
                          )
                        }
                      </span>
                    </td>
                  </tr>
                  )
                })
              : <h3 className="text-center border-bottom pt-2 pb-4">Empty Cart</h3>
              }
            </tbody>
          </table>
        </div>
        <div className="my-3">
          <table className="w-100">
            <thead>
              {/* <tr>
                <th scope="col"><span className="visually-hidden">Description</span></th>
                <th scope="col"><span className="visually-hidden">Price</span></th>
              </tr> */}
            </thead>
            <tbody>
              <tr>
                <th scope="row">Subtotal</th>
                <td className="text-right">
                  <span>
                    {props.currency === "USD"? 
                      new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                        sumBy(props.carts, "oriTotalNetAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "oriTotalAmount")))
                      )
                      :
                      new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                        sumBy(props.carts, "oriTotalNetAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "oriTotalAmountMYR")))
                      )
                    }
                  </span>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <span>
                    Shipping
                  </span>
                </th>
                <td className="text-right">
                  {props.shippingFee ?
                    countShipping()
                    : (props.countryCode === 'MY' ? '-' : (<span>Fill in address to check shipping cost</span>))}
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <span>
                    Discount
                  </span>
                </th>
                <td className="text-right">
                  {props.currency === "USD"? 
                      new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                        (
                          sumBy(props.carts, "discountAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "discountAmount")))
                        )
                      )
                      :
                      new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                        (
                          sumBy(props.carts, "discountAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "discountAmountMYR")))
                        )
                      )
                    }
                </td>
              </tr>
              {/* <tr>
                <th scope="row">
                  <span>
                    Spec Discount
                  </span>
                </th>
                <td className="text-right">
                  {props.currency === "USD"? 
                      new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                        (
                          sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "discountAmount")))
                        )
                      )
                      :
                      new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                        (
                          sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "discountAmount")))
                        )
                      )
                    }
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <span>
                    Product Discount
                  </span>
                </th>
                <td className="text-right">
                  {props.currency === "USD"? 
                      new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                        (
                          sumBy(props.carts, "discountAmount")
                        )
                      )
                      :
                      new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                        (
                          sumBy(props.carts, "discountAmount")
                        )
                      )
                    }
                </td>
              </tr> */}
              {/* <tr>
                <th scope="row">Taxes (estimated)</th>
                <td className="text-right">
                  <span>$0.00</span>
                </td>
              </tr> */}
            </tbody>
          </table>
          {props?.appliedVouchers?.length > 0 && (
            <div className="space-y-2">
              <p className="text-sm mb-1 font-weight-bold">Applied Vouchers 
                {/* ({props?.appliedVouchers?.length}/3): */}
                </p>
              <div className="flex flex-wrap gap-2">
                {props?.appliedVouchers?.map((voucher) => (
                  <Badge key={voucher.code} variant="secondary" className="flex items-center gap-4 mr-2">
                    {voucher.code} ({voucher.percentage}% off)
                    <div variant="ghost" size="icon" style={{display: 'inline-block', cursor: 'pointer'}} className="cursor-pointer p-0" onClick={() => props?.removeVoucher(voucher)}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                      </svg>
                    </div>
                  </Badge>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="border-top py-3">
          <Media>
            <Media body>
              <p>Total</p>
            </Media>
            <Media body>
              <div className="text-right">
                <span className="d-inline-block pr-2">{props.currency}</span>
                <h3 className="d-inline-block">
                  {props.currency === "USD"? 
                    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
                      (
                        sumBy(props.carts, "totalNetAmount")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmount")))+props.shippingFee
                      )
                    )
                    :
                    new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(
                      (
                        sumBy(props.carts, "totalNetAmountMYR")+sumBy(props.carts.filter(element => !isEmpty(element.variations)).map(sum => sumBy(sum.variations, "totalAmountMYR")))+props.shippingFeeMYR
                      )
                    )
                  }
                </h3>
              </div>
            </Media>
          </Media>
        </div>
      </div>
    </>
  );
}
 
export default Calculate;